export default __webpack_public_path__ + "static/media/arrow_wallet.e29f0098.svg";